import { Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CallIcon from '@material-ui/icons/Call';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import DataAi from 'src/components/DataAi';
import axios from 'src/utils/axios';
import { getKoordinat } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { forms } from 'src/views/Form';
import BasvuruNedeniSearch from '../../../components/Selects/AppReasonSearch';
import BayiSearch from '../../../components/Selects/DealerSearch';
import { text } from '../../../modules/languages/index';
import FgsArama from '../../Overview/FgsCall';
import CustomerPermision from './CustomerPermision';




const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    minHeight: 370,
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },

}));

function CustomerInfo({ customer, readonly, FisNoParam, className, tasks }) {
  const [open1, setOpen1] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const classes = useStyles();
  const [openEdit, setOpenEdit] = useState(false);
  const [openFgsArama, setOpenFgsArama] = useState(false);
  const [FisNo, setFisNo] = useState("");
  const [data, setData] = useState({});
  const [dataBn, setDataBn] = useState({ BasvuruNedeni: '' });
  const [AiOpen, setAiOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [MusteriBilgileri, setMusteriBilgileri] = React.useState("");
  const [newBasvuru, setNewBasvuru] = useState('');
  const [loading, setLoading] = useState(false);
  const [formOpen, setFormOpen] = useState(false);

  const history = useHistory();
  const setModel = (param) => {

    setNewBasvuru(param.ACIKLAMA);
    setDataBn({ BasvuruNedeni: param.ACIKLAMA });

  }
  const search = "";

  const tasksList = tasks?.tasks;

  useEffect(() => {

    let storeData = readonly 
      ? (Array.isArray(tasksList) ? tasksList.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : [])
      : loadBaslandiJob();

    if (!readonly && (!storeData || storeData.length === 0)) {
      const current = tasksList?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
      if (current) {
        saveBaslandiJob(current);
        storeData = loadBaslandiJob();
      }
    }


    if (Array.isArray(storeData) && storeData.length > 0) {
      setData(storeData[0]);
    } else {
      setData({});
    }
  }, [FisNo, tasksList, readonly]);


  const handleEditOpen = () => {
    setOpenEdit(true);
  };
  const HaritaAc = (Enlem, Boylam) => {
    window.open(process.env.REACT_APP_MAP_URL + Enlem + "," + Boylam);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  const handleFgsAramaOpen = (AtananIsFisNo) => {
    setOpenFgsArama(true);
    setFisNo(AtananIsFisNo?.toString() || '');
  }
  const handleFgsAramaClose = () => {
    setOpenFgsArama(false);
  }

  const setBayi = (param) => {
    if (readonly) {
      return;
    }

    const jobs = loadBaslandiJob();
    let job = (jobs && jobs.length > 0) ? jobs[0] : {};
    job = {
      ...job,
      KUL_BAYI_KODU: param.KUL_BAYI_KODU,
      BAYI_ACIKLAMA: param.ACIKLAMA,
      BAYI_KODU: param.BAYI_KODU,
    }
    saveBaslandiJob(job);
    setData(job);

  }

  const statusUpdate = (job) => {
    if (newBasvuru === undefined || newBasvuru === '') {
      setUyari("Lütfen Başvuru Nedeni Seçiniz!...");
      setOpen1(true);
      return;
    }
    setLoading(true);
    const dataReq = [{
      BASVURU_NEDENI: newBasvuru,
      FIS_NO: job.FisNo,
      MUSTERI_NO: job.MusteriNo,
      BIRIM_KODU: job.BIRIM_KODU,
      TEKNISYEN_KODU: job.TEKNISYEN_KODU,
      MODEL_KODU: 0,
      ENLEM: getKoordinat("Enlem"),
      BOYLAM: getKoordinat("Boylam"),
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }


    axios.post('/SetArtemisServicePaperCreate', dataReq, config).then(response => {
      let ResponseData = response.data?.[0] || {};
      setUyari(ResponseData.ErrorDescription);
      setOpen1(true);
      setLoading(false);
      handleClose();
    })
  }
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseP = () => {
    setOpen1(false);
  };
  const handleClickOpen = (job) => {
    setOpen(true);
    setMusteriBilgileri(`Müşterimiz ${job.Musteri} için yeni bir fiş yaratmak istiyor musunuz? `);
  };


  return (
    <div>
      <Card
        className={clsx(classes.root, className)}
      >
        <CardHeader
          title="Müşteri Detay" />
        <Divider />
        <CardContent className={classes.content}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography className={classes.title} color="textSecondary">
                {text("Telefon_Arayan")}
              </Typography>
              <Typography variant="h6"
                onClick={() => handleFgsAramaOpen(customer.FisNo)}
                gutterBottom>
                <u>{customer?.Telefon?.length > 0 && customer.Telefon}</u>
                <u>{customer?.Telefon2?.length > 0 && ' - ' + customer.Telefon2}</u>
                <u>{customer?.Telefon3?.length > 0 && ' - ' + customer.Telefon3}</u>
                <u>{customer?.ArayanTelefon?.length > 0 && ' / ' + customer.ArayanTelefon}</u>
                <u>{customer?.IrtibatTelefon?.length > 0 && ' / ' + customer.IrtibatTelefon}</u>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.title} color="textSecondary">
                {"Müşteri Tipi"}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {customer?.MusteriTipi}
              </Typography>
            </Grid>
            <Grid item xs={12}><Divider /></Grid>
            <Grid item xs={12}>
              <Typography className={classes.title} color="textSecondary">
                {text("Adres")}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {customer?.ADRES}<br />{customer?.Mahalle} {customer?.ILCE} {customer?.IL}
              </Typography>
            </Grid>
            <Grid item xs={12}><Divider /></Grid>
            <Grid item xs={12}>
              <Typography className={classes.title} color="textSecondary">
                {"Bayi Deposu"}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {customer.DEPO ?
                  customer.DEPO || ''
                  + " " +
                  customer.DEPO_ADRES || ''
                  + " " +
                  customer.DEPO_RANDEVU || ''
                  : 'Bayi Deposu Bulunamadı!...'
                }
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" component="h2" gutterBottom>
                {readonly ?
                  customer.KUL_BAYI_KODU + ' - ' + customer.BAYI_ACIKLAMA
                  :
                  <BayiSearch setModel={setBayi} value={{
                    KUL_BAYI_KODU: data.KUL_BAYI_KODU || '',
                    ACIKLAMA: data.BAYI_ACIKLAMA || ''
                  } || ''}
                    searchParam={search}
                  />
                }
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Grid container spacing={1} >
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setAiOpen(true)}
                fullWidth
                endIcon={<CallIcon />}>
                {'Görüşme Özetİ'}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleClickOpen(customer)}
                fullWidth
                endIcon={<PlaylistAddIcon />}>
                {'Yenİ İş Emrİ'}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleEditOpen}
                disabled={readonly}
                fullWidth
                endIcon={<EditIcon />}>
                {text("izinleri_Düzenle")}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setFormOpen(true)}
                disabled={readonly}
                fullWidth
                endIcon={<PostAddIcon />}>
                FORMLAR
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
              onClick={() => HaritaAc(customer.ENLEM, customer.BOYLAM)}
                disabled={readonly}
                fullWidth
                endIcon={<NotListedLocationIcon />}>
                {text("Yol_Tarifi_Al")}
              </Button>
            </Grid>
          </Grid>
        </CardActions>
        <CustomerPermision
          customer={customer}
          onClose={handleEditClose}
          open={openEdit}
        />
        <FgsArama
          onClose={handleFgsAramaClose}
          FisNo={FisNo}
          open={openFgsArama}
        />
      </Card>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}>
        {loading ? <CircularProgress
          status={'loading'}
          style={{ marginLeft: '50%' }} />
          : <div></div>
        }
        <DialogTitle id="alert-dialog-title">
          {MusteriBilgileri}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <Typography className={classes.title} color="textSecondary" gutterBottom component="div">
              Başvuru Nedeni
            </Typography>
            <Typography variant="h6" component="div">
              <BasvuruNedeniSearch setModel={setModel}
                value={{ ACIKLAMA: dataBn.BasvuruNedeni || '', } || ''}
                searchParam={search}
              />
            </Typography>
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => statusUpdate(customer, 1)}
            disabled={loading}
            className={classes.button}
            endIcon={<AddIcon />}>
            Oluştur
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            className={classes.button}
            endIcon={<CloseIcon />}>
            İptal
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={formOpen}
        onClose={() => setFormOpen(false)}
        fullWidth={true}>
        <DialogTitle id="alert-dialog-title">
          Keşif Formları
        </DialogTitle>
        <Divider />

        <DialogContent>
          <Grid container spacing={2}>
            {Array.isArray(forms) && forms
              .filter(f =>
                f.basvuruNedeni ===
                (customer.BasvuruNedeni === 'Davlumbaz-Genel Bakım//Temizlik//Kontrol'
                  ? 'Aspiratör-Genel Bakım//Temizlik//Kontrol'
                  : customer.BasvuruNedeni) || f.basvuruNedeni === '-'
              )
              .map(f => (
                <Grid item xs={12} key={f.key}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    endIcon={f.icon}
                    onClick={() => history.push(`/Form/${f.key}/${FisNoParam}`)}
                  >
                    {f.value}
                  </Button>
                </Grid>
              ))}
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setFormOpen(false)}
            endIcon={<CloseIcon>Close</CloseIcon>}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open1}
        onClose={handleCloseP}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseP} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      {AiOpen ? <DataAi AiOpen={AiOpen} setAiOpen={setAiOpen} FisNo={customer?.FisNo} Telefon={customer?.ArayanTelefonOffline} /> : ''}
    </div>
  );
}

CustomerInfo.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.object.isRequired
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(CustomerInfo);
